<template>
  <v-btn icon small :loading="loading" @click.stop="onClick">
    <v-icon :color="color">
      {{ icon }}
    </v-icon>
  </v-btn>
</template>

<script>
import RespostaService from './resposta-service';

export default {
  props: {
    cotacao: Object,
    resposta: Object,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    icon() {
      if (this.resposta && this.resposta.favorito) {
        return 'mdi-star';
      }
      return 'mdi-star-outline';
    },
    color() {
      if (this.resposta && this.resposta.favorito) {
        return 'yellow';
      }
      return null;
    },
  },
  methods: {
    favoritar() {
      this.loading = true;
      RespostaService.favoritar(this.cotacao.id, this.resposta.id)
        .then(() => {
          this.$emit('update');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClick() {
      this.favoritar();
    },
  },
};
</script>
